/* eslint-disable @typescript-eslint/no-explicit-any */
import log, {RootLogger} from 'loglevel';

const remote = require('loglevel-plugin-remote');

let instance: Logger | null = null;

class Logger {
  private log?: RootLogger;

  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }

  init() {
    if (!this.log) {
      const customJSON = (log: any) => ({
        msg: log.message,
        level: log.level.label,
        stacktrace: log.stacktrace,
      });
      remote.apply(log, {format: customJSON, url: ''});
      log.enableAll();
      this.log = log;
    }
  }

  trace(...args: any[]): void {
    this.log?.trace(...args);
  }

  debug(...args: any[]): void {
    this.log?.debug(...args);
  }

  info(...args: any[]): void {
    this.log?.info(...args);
  }

  warn(...args: any[]): void {
    this.log?.warn(...args);
  }

  error(...args: any[]): void {
    this.log?.error(...args);
  }
}

export default new Logger();
